(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mapapp-preview]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const dialog = document.createElement('dialog');
    dialog.className = 'mapapp-cart-preview';
    dialog.setAttribute('aria-label', trigger.dataset.previewTitle);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'mapapp-cart-preview__close';
    close.textContent = trigger.dataset.previewClose;
    close.autofocus = true;
    const image = document.createElement('img');
    image.className = 'mapapp-cart-preview__image';
    image.alt = trigger.querySelector('img')?.alt || trigger.dataset.previewTitle;
    const error = document.createElement('p');
    error.hidden = true;
    error.setAttribute('role', 'status');
    error.textContent = trigger.dataset.previewError;
    image.addEventListener('error', () => { image.hidden = true; error.hidden = false; });
    image.src = trigger.href;
    dialog.append(close, image, error);
    document.body.append(dialog);
    const previousOverflow = document.documentElement.style.overflow;
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      dialog.remove();
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    }, { once: true });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  });
  } catch(e) { console.error(e); }
})();

})();
